'use strict';

/* Kalis Media 2021
 * To use this module add following line to theme.liquid, just before </body> tag
 * <script src="//lokk.no/cdn/shop/t/28/assets/kalis-teams-menu-mobile.js?v=157707907165054303091792870200" defer="defer"></script>
 *
 * To work this script needs a specific Impulse theme setup
 * Four main menu links are set: MLB, NBA, NFL, NHL, all on the third mega menu level
 * Below those links all the links "under" with team names are set on the same level
 * This script hides all team links, but not those four special links
 * When hovering over a special link it shows those themes
 */

// window.addEventListener('load', function() {

(function init() {
  (function init() {
    var data = {
      MLB: {
        main: $('a.mobile-nav__link[href*="/collections/mlb"]'),
        teams: findLinksByString(' - MLB')
      },
      NBA: {
        main: $('a.mobile-nav__link[href*="/collections/nba"]'),
        teams: findLinksByString(' - NBA')
      },
      NFL: {
        main: $('a.mobile-nav__link[href*="/collections/nfl"]'),
        teams: findLinksByString(' - NFL')
      },
      NHL: {
        main: $('a.mobile-nav__link[href*="/collections/nhl"]'),
        teams: findLinksByString(' - NHL')
      }
    };

    hideTeams(data);

    moveMainButtonsToTop(data);

    onClickShowForAllMainButtons(data);
  })();

  function findLinksByString(search) {
    var results = $();
    var links = $('a.mobile-nav__link');

    // img
    $.each(links, function(index, link) {
      var alt = $(link).find('img').attr('alt');
      if (alt && alt.indexOf(search) !== -1) {
        $(link).html($(link).html().split(search).join('')); // remove " - NHL" from titles
        results = results.add($(link));
      }
    });

    return results;
  }

  function hideTeams(data) {
    data.MLB.teams.slideUp(300);
    data.NBA.teams.slideUp(300);
    data.NFL.teams.slideUp(300);
    data.NHL.teams.slideUp(300);
  }

  function moveMainButtonsToTop(data) {
    var $ul = data.MLB.main.parents('ul.mobile-nav__sublist');
    $ul.prepend(data.NHL.main);
    $ul.prepend(data.NFL.main);
    $ul.prepend(data.NBA.main);
    $ul.prepend(data.MLB.main);
  }

  function onClickShowForAllMainButtons(data) {
    onClickShowForButton(data, data.MLB.main, data.MLB.teams);
    onClickShowForButton(data, data.NBA.main, data.NBA.teams);
    onClickShowForButton(data, data.NFL.main, data.NFL.teams);
    onClickShowForButton(data, data.NHL.main, data.NHL.teams);
  }

  function onClickShowForButton(data, main, teams) {
    main.on('click', function(event) {
      event.preventDefault();

      if (main.data('clicked') === true) {
        data.MLB.main.data('clicked', false);
        data.NBA.main.data('clicked', false);
        data.NFL.main.data('clicked', false);
        data.NHL.main.data('clicked', false);
        data.MLB.main.find('img').css('opacity', '1');
        data.NBA.main.find('img').css('opacity', '1');
        data.NFL.main.find('img').css('opacity', '1');
        data.NHL.main.find('img').css('opacity', '1');
        hideTeams(data);
        setTimeout(function() { // Must wait for animation to finish
          fixHeightOfParentContainer(main);
        }, 300);
        return;
      }

      highlightMain(data, main);

      main.data('clicked', true);
      hideTeams(data);
      teams.slideDown(300);
      fixHeightOfParentContainer(main);
    });
  }

  function highlightMain(data, mainToHighlight) {
    data.MLB.main.find('img').css('opacity', '0.4');
    data.NBA.main.find('img').css('opacity', '0.4');
    data.NFL.main.find('img').css('opacity', '0.4');
    data.NHL.main.find('img').css('opacity', '0.4');
    mainToHighlight.find('img').css('opacity', '1');
  }

  function fixHeightOfParentContainer(main) {
    var $sublist = $(main).parent('ul.mobile-nav__sublist');
    var $mobileNavSublist = $sublist.parent('.collapsible-content__inner').parent('.mobile-nav__sublist');
    $mobileNavSublist.css('height', $sublist.height());
  }

})();
